import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);
export const supabaseConfigError = isSupabaseConfigured
  ? null
  : 'Supabase ist nicht konfiguriert. Bitte VITE_SUPABASE_URL und VITE_SUPABASE_ANON_KEY setzen.';

if (!isSupabaseConfigured && import.meta.env.DEV) {
  console.warn(supabaseConfigError);
}

// Keep imports safe even when env vars are missing so public pages do not white-screen.
// Supabase calls will fail gracefully until the real project URL/key are configured.
export const supabase = createClient(
  supabaseUrl ?? 'https://missing-supabase-url.supabase.co',
  supabaseAnonKey ?? 'missing-supabase-anon-key'
);

// Type definitions for our registration data
export interface RegistrationData {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  gender: string;
  age: number;
  instagram?: string;
  current_level: string;
  selected_course: string;
  start_date: string; // JSON string storing user preference like "asap", "contact-me", etc.
  payment_method: string;
  privacy_accepted: boolean;
  terms_accepted: boolean;
  withdrawal_consent: boolean;
  newsletter_opt_in: boolean;
  created_at?: string;
}

// Type definitions for contact form data
export interface ContactSubmissionData {
  name: string;
  email: string;
  subject: string;
  course?: string;
  message: string;
  privacy_accepted: boolean;
  created_at?: string;
}

// Type definitions for course data
export interface CourseData {
  id?: string;
  level: string;
  title: string;
  description: string;
  duration: string;
  sessions: string;
  color: string;
  books: string[];
  skills: string[];
  is_active: boolean;
  max_participants: number;
  price_monthly: number;
  price_full: number;
  created_at?: string;
  updated_at?: string;
}